import { render, staticRenderFns } from "./ForceActiveMerchant.vue?vue&type=template&id=6a92f24e"
import script from "./ForceActiveMerchant.vue?vue&type=script&lang=js"
export * from "./ForceActiveMerchant.vue?vue&type=script&lang=js"
import style0 from "./ForceActiveMerchant.vue?vue&type=style&index=0&id=6a92f24e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports